"use client";

import Image from "next/image";
import { t } from "@/lib/localization";

interface LogoProps {
    className?: string;
    width?: number;
    height?: number;
    fill?: boolean;
    color?: "primary" | "white";
}

export default function Logo({
    className,
    width = 633,
    height = 238,
    fill = false,
    color = "primary",
}: LogoProps) {
    const src = `/images/branding/logo/yeda${color === "white" ? "-white" : ""}.svg`;

    return (
        <Image
            className={className}
            src={src}
            alt="logo"
            {...(fill ? { fill: true } : { width, height })}
        />
    );
}
